/**
 * Copyright Highway9 Networks Inc.
 */
import { Order } from '~/types/order';
import { authenticationService } from './authentication-service';
import { ServerLocation } from '~/types/serverLocation';

export const orderService = {
    getOrders,
    createOrder,
    getLocations
};

async function getOrders(limit = 20, offset = 1) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'accept': 'application/json',
            'Authorization': 'Bearer ' + authenticationService.currentUserValue?.token,
        },
    };

    try {
        const response = await fetch(`/api/serviceOrdering/v4/serviceOrder?limit=${limit}&offset=${offset}`, requestOptions);
        const data = await response.json() as Order[];
        const total = Number(response.headers.get('x-total-count')) ?? 0;
        return { data, total };
    } catch (error) {
        console.error(error);
        throw error;
    }
}

function createOrder(order: any) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'accept': 'application/json',
            'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
        },
        body: JSON.stringify(order)
    };

    console.log("Creating order... ");
    return fetch(`/api/serviceOrdering/v4/serviceOrder`, requestOptions)
}

async function getLocations() {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'accept': 'application/json',
            'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
        },
    };
    try {
        const response = await fetch(`api/v1/saas/location`, requestOptions);
        const data = await response.json();
        return data.data as ServerLocation[];
    } catch (error) {
        console.error(error);
        throw error;
    }
}